/*
    ** Wrapper table
*/
let width = document.body.clientWidth;

if (document.querySelectorAll('.textimg table').length > 0) {
    let tbls = document.querySelectorAll('.textimg table');
    for (const tbl of tbls) {
        let parent = tbl.parentNode;
        let wrapper = document.createElement('div');
        wrapper.style.overflowX = "auto";
        wrapper.style.webkitOverflowScrolling = "touch";
        wrapper.style.overscrollBehaviorX = "contain";
        wrapper.classList.add('wrapper-table');
        wrapper.classList.add('br-5');
        parent.insertBefore(wrapper, tbl);
        wrapper.appendChild(tbl);
    }
}